import { Authenticated, useTranslate } from "@refinedev/core";
import { Col, Flex, Row } from "antd";
import { useState } from "react";
import { PageLayout } from "components/PageLayout";
import { SectionTitle } from "@libertify/ui";
import { TutorialCard } from "./components/TutorialCard";
import { TutorialSection } from "./components/TutorialSection";
import { TutorialVideoModal } from "./components/TutorialVideoModal";
import {
  EDUCATION_TUTORIALS,
  NOT_READY_TUTORIALS,
  Tutorial,
  VIDEO_TUTORIALS,
} from "./tutorials.data";
import { getTutorialEmbedUrl } from "./tutorialVideo";

type ActiveTutorial = { tutorial: Tutorial; lessonNumber: number };

export const TutorialsPage = () => {
  const t = useTranslate();
  const [active, setActive] = useState<ActiveTutorial | null>(null);
  const handleSelect = (tutorial: Tutorial, lessonNumber: number) =>
    setActive({ tutorial, lessonNumber });

  return (
    <Authenticated key="tutorials">
      <PageLayout
        title={t("pages.tutorials.title")}
        description={
          <Row>
            <Col md={24} lg={12}>
              {t("pages.tutorials.description")}
            </Col>
          </Row>
        }
      >
        <Flex vertical gap={56}>
          <TutorialSection
            title={t("pages.tutorials.categories.education")}
            tutorials={EDUCATION_TUTORIALS}
            onSelect={handleSelect}
          />

          <TutorialSection
            title={t("pages.tutorials.categories.video")}
            tutorials={VIDEO_TUTORIALS}
            onSelect={handleSelect}
          />

          {NOT_READY_TUTORIALS.length > 0 ? (
            <Flex vertical gap={16}>
              <SectionTitle>{t("pages.tutorials.comingSoon")}</SectionTitle>
              <Row gutter={[28, 28]}>
                {NOT_READY_TUTORIALS.map((tutorial) => (
                  <Col key={tutorial.titleKey} xs={24} sm={12} lg={8}>
                    <TutorialCard
                      status={tutorial.status}
                      title={t(tutorial.titleKey)}
                      description={t(tutorial.descriptionKey)}
                      icon={tutorial.icon}
                    />
                  </Col>
                ))}
              </Row>
            </Flex>
          ) : null}
        </Flex>
      </PageLayout>

      <TutorialVideoModal
        lessonNumber={active ? active.lessonNumber : null}
        title={active ? t(active.tutorial.titleKey) : null}
        embedUrl={active ? getTutorialEmbedUrl(active.tutorial.videoUrl) : null}
        onClose={() => setActive(null)}
      />
    </Authenticated>
  );
};
